import { render, staticRenderFns } from "./giochi.vue?vue&type=template&id=513a6290&scoped=true&"
import script from "./giochi.vue?vue&type=script&lang=js&"
export * from "./giochi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513a6290",
  null
  
)

export default component.exports